import { render } from "./courseStatistical.vue?vue&type=template&id=2ec3cdea&scoped=true"
import script from "./courseStatistical.vue?vue&type=script&lang=js"
export * from "./courseStatistical.vue?vue&type=script&lang=js"

import "./courseStatistical.vue?vue&type=style&index=0&id=2ec3cdea&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec3cdea"]])

export default __exports__